import React from 'react';
import Box from '@mui/material/Box';

const scaleMap = {
  none: 0,
  xs: 0.5,
  s: 1,
  m: 2,
  l: 3,
  xl: 4,
} as const;

const alignItemsMap = {
  stretch: 'stretch',
  flexStart: 'flex-start',
  flexEnd: 'flex-end',
  center: 'center',
} as const;

type StackProps = {
  children: React.ReactNode;
  scale?: 'none' | 'xs' | 's' | 'm' | 'l' | 'xl';
  className?: string;
  alignItems?: 'stretch' | 'flexStart' | 'flexEnd' | 'center';
};

const Stack = ({
  children,
  scale = 's',
  className,
  alignItems = 'stretch',
}: StackProps) => (
  <Box
    className={className}
    sx={{
      display: 'flex',
      flexDirection: 'column',
      gap: scaleMap[scale],
      alignItems: alignItemsMap[alignItems],
    }}
  >
    {children}
  </Box>
);

export default Stack;
